'use client';

import { Box, Container } from '@mui/material';
import { usePathname } from 'next/navigation';
import React from 'react';
import { useFullscreen } from '../app/contexts/FullscreenContext';

interface NavigationProps {
  children: React.ReactNode;
}

export default function Navigation({ children }: NavigationProps) {
  const pathname = usePathname();
  const { isFullscreen } = useFullscreen();

  const isAuthPage =
    pathname.startsWith('/login') ||
    pathname.startsWith('/register') ||
    pathname.startsWith('/forgot-password') ||
    pathname.startsWith('/reset-password') ||
    pathname.startsWith('/verify-email') ||
    pathname.startsWith('/confirm-email');
  const isWiderPage =
    pathname.startsWith('/app/admin') && !(pathname === '/app/admin');

  const isFullWidthPage =
    pathname.startsWith('/app/etapas') || pathname.startsWith('/app/results') || pathname.startsWith('/app/volta-final-2025');

  const isCleanLayoutPage =
    pathname.startsWith('/live-crono') ||
    pathname.startsWith('/live-video') ||
    pathname.startsWith('/app/home') ||
    pathname.startsWith('/mobile/home');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt:
            isAuthPage || isFullscreen || isCleanLayoutPage
              ? 0
              : { xs: 7, sm: 8 },
          pb:
            isAuthPage || isFullWidthPage || isFullscreen || isCleanLayoutPage
              ? 0
              : 3,
        }}
      >
        {isAuthPage || isCleanLayoutPage ? (
          children
        ) : (
          <Container
            maxWidth="xl"
            sx={{
              px: {
                xs: isFullWidthPage ? 0 : 1,
                sm: isFullWidthPage ? 0 : 2,
                md: 2,
              },
              maxWidth: isWiderPage ? '1800px !important' : 'unset',
            }}
          >
            {children}
          </Container>
        )}
      </Box>
    </Box>
  );
}
